import { gql } from '@apollo/client';

export const GET_REQUIRE_TASKS_BEFORE_JOINING = gql`
  query GetRequireTasksBeforeJoining {
    vm {
      configItem(key: "require-tasks-before-joining") {
        configItemId
        key
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;
